import { render, staticRenderFns } from "./VideoRecoments.vue?vue&type=template&id=cbf5b8de&scoped=true&"
import script from "./VideoRecoments.vue?vue&type=script&lang=js&"
export * from "./VideoRecoments.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecoments.vue?vue&type=style&index=0&id=cbf5b8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf5b8de",
  null
  
)

export default component.exports